import { render, staticRenderFns } from "./agentComplaintFeedback.vue?vue&type=template&id=77b7d8a4&scoped=true&"
import script from "./agentComplaintFeedback.vue?vue&type=script&lang=js&"
export * from "./agentComplaintFeedback.vue?vue&type=script&lang=js&"
import style0 from "./agentComplaintFeedback.vue?vue&type=style&index=0&id=77b7d8a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b7d8a4",
  null
  
)

export default component.exports